import {getIn} from 'formik';

export const getValidationErrorsFromArray = (field: any, form: any) => {
	if (!field?.name) return undefined;

	const error = getIn(form.errors, field.name);
	const touched = getIn(form.touched, field.name);

	if (touched && error) {
		return error;
	}

	return undefined;

	// if (!field?.name) return undefined;

	// const fieldNameParts = field.name.split('.');
	// const index = field.name.match(/\[(\d+)\]/)?.[1];

	// if (!index) {
	// 	return undefined;
	// }

	// const updatedFieldName = `${fieldNameParts[0].slice(0, -3)}.${fieldNameParts[1]}`.split('.');

	// let currentError = form.errors;
	// const currentTouched = form.touched;

	// if (
	// 	!currentError[updatedFieldName[0]] ||
	// 	!currentTouched[updatedFieldName[0]] ||
	// 	!currentTouched[updatedFieldName[0]][index]
	// ) {
	// 	return undefined;
	// }

	// for (const part of updatedFieldName) {
	// 	if (Array.isArray(currentError[part])) {
	// 		currentError = currentError[part][index];
	// 	} else if (currentError && currentError[part]) {
	// 		currentError = currentError[part];
	// 	} else {
	// 		return undefined;
	// 	}
	// }

	// return currentError;
};

export const getValidationErrorsFromObject = (field: any, form: any) => {
	const fieldNameParts = field.name.split('.');

	let currentError = form.errors;
	let currentTouched = form.touched;

	for (const part of fieldNameParts) {
		if (!currentError[part] || !currentTouched[part]) {
			return undefined;
		}

		currentError = currentError[part];
		currentTouched = currentTouched[part];
	}

	return currentTouched ? currentError : undefined;
};

export const isValidAmount = (value: string) => {
	const regex = /^\d*([.,]\d{0,2})?$/;
	return regex.test(value);
};
